module.exports = __webpack_public_path__ + "img/2025-09-19b_2.42ca4f85.jpg";